module.exports = __webpack_public_path__ + "static/media/topMoments.fc4f4926.svg";